import * as React from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { Link } from "react-router-dom";
import { users } from "@/api";
import { omit } from "@/util";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 30px;
    height: 80px;
    justify-content: center;
  }
`;

const LosePass: React.FunctionComponent = () => {
  const history = useHistory();
  const [downNumber, setDownNumber] = React.useState(0);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  React.useEffect(() => {
    if (downNumber > 0) {
      setTimeout(() => {
        setDownNumber(downNumber - 1);
      }, 1000);
    }
  }, [downNumber]);
/*React.useMemo被用来优化性能，避免在每次组件渲染时都重新计算buttonTxt的值。*/ 
  const buttonTxt = React.useMemo(
    () => (downNumber === 0 ? "发送验证码" : `${downNumber} S`),
    [downNumber]
  );

  const handleSubmit = async (values: any) => {
    values.checkCode=123456;
    const params: users.RegProps = omit(
      values,
      "cfmPassword"
    ) as users.RegProps;
    await users.forgetpassword(params);
    message.success("密码修改成功!");
    history.replace("/login");
  };

  const sendCaptcha = async () => {
    if (!/1[\d]{10}/.test(phoneNumber)) {
      message.error("手机号码不正确");
      return;
    }
    await users.sendcode(phoneNumber);
    setDownNumber(59);
  };

  const phoneChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setPhoneNumber(v);
  };

  return (
    <Container>
      <Form onFinish={handleSubmit}>
        <div className="atitle">
          <h2>忘记密码</h2>
        </div>
        <Form.Item
          name="username"
          rules={[{ required: true, message: "手机号码不能为空" }]}
        >
          <Input placeholder="请输入手机号码" onChange={phoneChangeHandler} />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "密码不能为空" }]}
        >
          <Input type="password" placeholder="请输入密码" />
        </Form.Item>
        <Form.Item
          name="cfmPassword"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("两次输入的密码不一致"));
              },
            }),
          ]}
        >
          <Input type="password" placeholder="请再次输入密码" />
        </Form.Item>

        {/* <Form.Item>
          <Row gutter={8}>
            <Col span={16}>
              <Form.Item
                name="checkCode"
                noStyle
                rules={[{ required: true, message: "验证码不能为空" }]}
              >
                <Input placeholder="请输入收到的验证码" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button onClick={sendCaptcha} block style={{ width: "100%" }}>
                {buttonTxt}
              </Button>
            </Col>
          </Row>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            修改
          </Button>
          <Link to="/login" className="mt10 fr">
            登录
          </Link>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default LosePass;
